module.exports = __webpack_public_path__ + "img/icon-info.573c718e.svg";